import React from 'react';
import config from 'config';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './ShareLinks.module.scss';

const ShareLinks = ({ Title, pathName, heading, padding, leftAligned }) => {
  const link = `${config.host}${pathName}`;
  const encodedTitle = encodeURIComponent(Title.replace(/&/g, 'and'));
  const encodedLink = encodeURIComponent(link);

  const componentStyles = classNames(styles.shareLinks, {
    [styles[`hasHeading__${heading}`]]: heading,
    [styles.padding]: padding,
    [styles.leftAligned]: leftAligned
  });

  const headingStyles = classNames(styles.heading, {
    [styles[`heading__${heading}`]]: heading
  });

  const handleClick = (event) => {
    event.preventDefault();
    const href = event.target.getAttribute('href'),
      title = event.target.getAttribute('title'),
      w = event.target.w || 560,
      h = event.target.h || 300;
    window.open(href, title, 'location=1,toolbar=0,' + popup_params(w, h));
  };

  return (
    <div className={componentStyles}>
      <h2 className={headingStyles}>Share</h2>
      <ul className={styles.items}>
        <li className={styles.item}>
          <a
            href={`//www.facebook.com/sharer/sharer.php?u=${encodedLink}`}
            className="icon-facebook"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClick}
          >
            <span className={styles.screenReaderText}>Share on Facebook</span>
          </a>
        </li>
        <li className={styles.item}>
          <a
            href={`//twitter.com/intent/tweet?text=${encodedTitle}+-+${encodedLink}+via+%40starlingbank`}
            className="icon-x"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClick}
          >
            <span className={styles.screenReaderText}>Share on Twitter</span>
          </a>
        </li>
        <li className={styles.item}>
          <a
            href={`//www.linkedin.com/shareArticle?mini=true&url=${encodedLink}&title=${encodedTitle}&summary=&source=`}
            className="icon-linkedin"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClick}
          >
            <span className={styles.screenReaderText}>Share on LinkedIn</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

const popup_params = (width, height) => {
  const a = typeof window.screenX !== 'undefined' ? window.screenX : window.screenLeft,
    i = typeof window.screenY !== 'undefined' ? window.screenY : window.screenTop,
    g = typeof window.outerWidth !== 'undefined' ? window.outerWidth : document.documentElement.clientWidth,
    f = typeof window.outerHeight !== 'undefined' ? window.outerHeight : document.documentElement.clientHeight - 22,
    h = a < 0 ? window.screen.width + a : a,
    left = parseInt(h + (g - width) / 2, 10),
    top = parseInt(i + (f - height) / 2.5, 10);
  return 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top + ',scrollbars=1';
};

ShareLinks.propTypes = {
  Title: PropTypes.string.isRequired,
  pathName: PropTypes.string.isRequired,
  heading: PropTypes.oneOf([null, 'above', 'inline']),
  padding: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['true', 'false'])]),
  leftAligned: PropTypes.bool
};

export default ShareLinks;
